import React from "react";
import {
  AuthPicWrapper,
  SignupContainer,
} from "../../components/auth/signup/Signup.style";
import Auth from "../../assets/auth/Auth.png";
import SignupComp from "../../components/auth/signup/SignupComp";

const Signup = () => {
  return (
    <SignupContainer>
      <SignupComp />
      <AuthPicWrapper>
        <img src={Auth} alt="Auth" />
      </AuthPicWrapper>
    </SignupContainer>
  );
};

export default Signup;
